<template>

  <el-container direction="vertical" style="background-color: #66c5f5">
    <el-header>
<!--      <div style="display: flex;flex-direction: row;justify-content: flex-end">-->
<!--       <div style="display: flex;flex-direction: column;justify-content: center;width: 0.8rem;height: 60px">-->
<!--         <div class="right-image" style="width: 0.7rem;height: 0.7rem"-->
<!--              @click="mrightClick"-->
<!--              :style="{ backgroundImage: 'url('+ rightImage +')'}"></div>-->
<!--       </div>-->
<!--      </div>-->
    </el-header>
    <el-main style="width: 100%;padding: 0;background-color: #66c5f5">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="color: black">
        <el-tab-pane label="本期学习" name="first">
          <template>
            <div>
              <ClassNowList
                  :good-list="info.bastList"
                  :is-sort="false"
              ></ClassNowList>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="往期学习" name="second">
          <template>
            <div style="background-color: #66c5f5">
              <OldClassChannelList
                  :good-list="info.bastList1"
                  :is-sort="false"
              ></OldClassChannelList>
            </div>
          </template>
        </el-tab-pane>
        <el-tab-pane label="阅读频道" name="third">
          <template>
            <div>
              <ClassChannelList
                  :good-list="info.bastList2"
                  :is-sort="false"
              ></ClassChannelList>
            </div>
          </template>
        </el-tab-pane>
<!--        <el-tab-pane label="知识竞赛" name="four">-->
<!--          <template>-->
<!--              <ZsjsCom></ZsjsCom>-->
<!--          </template>-->
<!--        </el-tab-pane>-->
      </el-tabs>
    </el-main>
    <el-footer></el-footer>
  </el-container>
</template>
<script>

import rightImage from "@/assets/images/lessTop.png";


import debounce from "lodash.debounce";
import {queryLessonList} from "@api/lesson";
import {trim} from "../../utils";
import ClassChannelList from "@components/ClassChannelList";
import OldClassChannelList from "@components/OldClassChannelList";
import ClassNowList from "@components/ClassNowList";
// import ZsjsCom from "@components/ZsjsCom";
// import OldPeriodClassList from "@components/OldPeriodClassList";

export default {
  name: "GoodsClass",
  // components: {ClassChannelList, ClassNowList,OldClassChannelList,ZsjsCom},
  components: {ClassChannelList, ClassNowList,OldClassChannelList},
  props: {},
  data: function () {
    return {
      rightImage: rightImage,
      category: [],
      navActive: 0,
      activeName: "first",
      search: "",
      lock: false,
      type: "本期学习",
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList1: [],
        bastList2: [],
        bastList3: [],
        bastList4: [],
        bastList5: [],
        bastList: [
          // {
          //     cate_name: "第十季第3期",
          //     image: require("@assets/images/classChannel/mainLessions/1003.png"),
          //     id: 1,
          //     tag: "网上主题团课",
          //     time:"2020-10-26",
          //     count:"5476040",
          //     url:"http://h5.cyol.com/special/daxuexi/10olekhqva3/index.html"
          //
          // }, {
          //     cate_name: "第十季第2期",
          //     image: require("@assets/images/classChannel/mainLessions/1002.jpg"),
          //     id: 1,
          //     tag: "网上主题团课",
          //     time:"2020-10-26",
          //     count:"5476040",
          //     url:"hhttp://h5.cyol.com/special/daxuexi/10csuyneyz2/index.html"
          // }, {
          //     cate_name: "第十季第1期",
          //     image: require("@assets/images/classChannel/mainLessions/1001.jpg"),
          //     id: 1,
          //     tag: "网上主题团课",
          //     time:"2020-10-26",
          //     count:"5476040",
          //     url:"http://h5.cyol.com/special/daxuexi/10poxiurcb1/index.html"
          // }, {
          //     cate_name: "内蒙古青年复习周：制度自信",
          //     image: require("@assets/images/classChannel/mainLessions/fuxizhou.png"),
          //     id: 1,
          //     tag: "网上主题团课",
          //     time:"2020-10-26",
          //     count:"5476040",
          //     url:"http://www.baidu.com"
          // }, {
          //     cate_name: "第九季第13期",
          //     image: require("@assets/images/classChannel/mainLessions/0913.jpg"),
          //     id: 1,
          //     tag: "网上主题团课",
          //     time:"2020-10-26",
          //     count:"5476040",
          //     url:"http://www.baidu.com"
          // }, {
          //     cate_name: "第九季第12期",
          //     image: require("@assets/images/classChannel/mainLessions/0912.png"),
          //     id: 1,
          //     tag: "网上主题团课",
          //     time:"2020-10-26",
          //     count:"5476040",
          //     url:"http://www.baidu.com"
          //
          // }, {
          //     cate_name: "第九季第11期",
          //     image: require("@assets/images/classChannel/mainLessions/0911.png"),
          //     id: 1,
          //     tag: "网上主题团课",
          //     time:"2020-10-26",
          //     count:"5476040",
          //     url:"http://www.baidu.com"
          // },
        ]
      }
    };
  },
  // watch: {
  //     "$route.params.pid": function (n) {
  //         if (n) {
  //             this.activeCateId(n);
  //         }
  //     }
  // },
  mounted: function () {
    let newTab = this.$route.query.tabName;

    if (typeof newTab !== 'undefined') {
      this.activeName = newTab;
      if (this.activeName === "second") {
        this.type = "往期学习";
      } else if (this.activeName === "third") {
        this.type = "阅读频道";
      } else if (this.activeName === "first"){
        this.type = "本期学习";
      }else{
        this.type = "往季学习";
      }
      console.log("activeName:" + this.activeName + " type:" + this.type)
    }
    this.getLessionsList(this.type, this.activeName);
    document.addEventListener("scroll", this.onScroll, false);
  },
  methods: {
    mrightClick() {
      this.$router.push({
        path: "/Billboard"
      });
    },
    handleClick(tab) {
      console.log(tab.name);
      this.getLessionsList(tab.label, tab.name);
    },
    getLessionsList(type, name) {
      var params = {
        classType: type
      }
      queryLessonList(params).then(response => {
        let loading = this.$weui.loading("数据加载中");
        // console.log(response.lessonList)
        if (name == 'first') {
          this.info.bastList = response.lessonList;
        } else if (name == 'second') {
          this.info.bastList1 = response.lessonList;
        } else if (name == 'third') {
          this.info.bastList2 = response.lessonList;
        } else if (name == 'four') {
          // this.info.bastList3 = response.lessonList;
        } else if (name == 'five') {
          this.info.bastList4 = response.lessonList;
        } else if (name == 'six') {
          this.info.bastList5 = response.lessonList;
        }
        loading.hide();
        console.log( response.lessonList)
      });

      // console.log("团课内容");
    },
    activeCateId(n) {
      let index = 0;
      n = parseInt(n);
      if (!n) return;
      this.category.forEach((cate, i) => {
        if (cate.id === n) index = i;
      });

      if (index !== this.navActive) {
        this.asideTap(index);
      }
    },
    submitForm: function () {
      var val = trim(this.search);
      if (val) {
        this.$router.push({
          path: "/goods_list",
          query: {s: val}
        });
        setTimeout(() => (this.search = ""), 500);
      }
    },
    asideTap(index) {
      const top =
          this.$refs.title[index].offsetTop -
          this.$refs.header.offsetHeight -
          window.scrollY;

      this.lock = true;

      window.scrollBy({top, left: 0, behavior: "smooth"});
      this.navActive = index;
    },
    onScroll: debounce(function () {
      if (this.lock) {
        this.lock = false;
        return;
      }
      const headerHeight = this.$refs.header.offsetHeight,
          {scrollY} = window,
          titles = this.$refs.title;
      titles.reduce((initial, title, index) => {
        if (initial) return initial;
        const parent = title.parentNode || title.parentElement;
        if (
            scrollY + headerHeight + 15 <
            title.offsetTop + parent.offsetHeight
        ) {
          initial = true;
          this.navActive = index;
        }
        return initial;
      }, false);
    }, 500)
  },
  beforeDestroy: function () {
    document.removeEventListener("scroll", this.onScroll, false);
  },
  handleLoad(e) {
    console.log("加载完成：" + e);
  }
};
</script>
<style>
.right-image {
  background-repeat: no-repeat;
  background-size: 100% auto;
}
/* 修改tab的样式一定要删除style标签后的scoped */
.el-tabs__item {
  font-size: 15px !important;
  color: white !important;
  /*color: #ffffff !important;*/
  padding: 0px 1vh 6vw 6vw !important;
  width: 45% !important;
  text-align: center;
}

.el-tabs__header {
  margin-right: auto !important;
  color: black !important;
  width: 100% !important;
  height: 8vh !important;
  background-color: #17a4f4 !important;
}

.xxpd_bg {
  text-align: center;
  /*background-image: linear-gradient(-180deg, #f86d6d 0%, #ff2323 100%);*/
  /*background-image: radial-gradient(circle, #f86d6d, #ff2323);*/
  background-image: url("../../assets/images/classChannel/xxpd.jpg");
  /*background-repeat: no-repeat;*/
  background-size: 100% 100%; /*按比例缩放*/
  height: 100%;
}
.el-header {
  width: 100% !important;
  height: 8vh !important;
  text-align: center !important;
  background-size: 100% 100% !important; /*按比例缩放*/
  background-image: url("../../assets/images/classChannel/xxpd-tou.jpg");
}

.el-footer {
  text-align: center;
  background-color: #66c5f5;
}

.el-tabs__item.is-active {
  color: #003eab !important;
}
</style>
